import React from 'react';
import {
  Box,
  TextField,
  IconButton,
  InputAdornment,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

const SearchFilterBar = ({
  searchTerm,
  viewType,
  onSearchChange,
  onSearchSubmit,
  onKeyPress,
  onViewTypeChange,
}) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      gap: 2,
      mb: 3,
      alignItems: { xs: 'stretch', md: 'center' },
      justifyContent: 'space-between'
    }}>
      <Box sx={{ display: 'flex', gap: 2, flex: 1, alignItems: 'center' }}>
        <TextField
          placeholder="Search collections..."
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyPress={onKeyPress}
          sx={{ minWidth: { xs: '100%', sm: 300 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => onSearchSubmit(searchTerm)} edge="end" size="small">
                  <FilterAltIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ToggleButtonGroup
          value={viewType}
          exclusive
          onChange={(_e, newValue) => newValue && onViewTypeChange(newValue)}
          size="small"
        >
          <ToggleButton value="grid" aria-label="grid view">
            <ViewModuleIcon />
          </ToggleButton>
          <ToggleButton value="list" aria-label="list view">
            <ViewListIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default SearchFilterBar;
